<!-- <app-loader *ngIf="showSpinner">
</app-loader> -->
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid">
    <div class="company-policy-section pt-3" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      @for (policy of policies; track policy; let i = $index) {
        <div class="card mb-3" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="card-header p-0" id="faqhead1">
            <a href="#" (click)="isCollapsed=i" class="btn btn-header-link collapsed py-4 " data-toggle="collapse"
              data-target="#faq1" aria-expanded="true" aria-controls="faq1">{{ policy.policy_title }} <span class="mr-5 pr-5">{{ policy.created_at
            | date : "dd MMM yyyy" }}</span></a>
          </div>
          <div [id]="'collapseViewMore-' + i" [collapse]="i!==isCollapsed" id="faq1" class="collapse"
            aria-labelledby="faqhead1" data-parent="#faq">
            <div class="card-body" [innerHtml]="policy.policy_description">
            </div>
          </div>
        </div>
      }
    </div>



  </div>
</main>